import type { IconProps as IconifyIconProps } from '@iconify/react';

import { Icon as IconifyIcon } from '@iconify/react';

type IconProps = IconifyIconProps;

export const Icon = ({ width = 20, ...props }: IconProps) => (
  <IconifyIcon width={width} {...props} />
);
